export var accessibilityMenuStrings = {
    animations: 'Animações',
};
